import React from 'react';
import {MenuItem} from '@gravity-ui/navigation';
import {Comments} from '@gravity-ui/icons';
import {ConversationsBadge} from '../../features/conversationFeed';

const conversationsStyles = {
  wrapper: {display: 'flex', alignItems: 'center', gap: 8},
  icon: {display: 'flex', alignItems: 'center', justifyContent: 'center'},
};

export const conversationsMenuItems: MenuItem[] = [
  {
    id: 'conversations',
    title: 'Переписка',
    icon: Comments,
    tooltipText: 'Переписка',
    pinned: true,
    rightAdornment: <ConversationsBadge />,
    itemWrapper: (p, makeItem) => {
      return (
        <div style={conversationsStyles.wrapper}>
          {makeItem({
            ...p,
            icon: (
              <div style={conversationsStyles.icon}>
                <Comments />
              </div>
            ),
          })}
        </div>
      );
    },
  },
  {
    id: 'conversations-list',
    title: 'Переписка',
    icon: Comments,
    href: '/conversations',
  },
];
